import { useState } from 'react';

import { ComboboxTags } from '@/components/ui/inputs/combobox-tags';
import { useTags } from '@/hooks/use-tags';

export interface ShipmentTableTagsProps {
  initialTags: string[];
  onUpdateTags: (updatedValue: string[]) => void;
}

const ShipmentTableTags = ({ initialTags, onUpdateTags }: ShipmentTableTagsProps) => {
  const { tags } = useTags();
  const [selectedTags, setSelectedTags] = useState(initialTags);

  const handleAddTag = (value: string) => {
    setSelectedTags([...selectedTags, value]);
  };

  const handleRemoveTag = (value: string) => {
    setSelectedTags(selectedTags.filter((selectedTag) => selectedTag !== value));
  };

  const handleUpdateTags = () => {
    onUpdateTags(selectedTags);
  };

  return (
    <ComboboxTags
      options={tags || []}
      onAddTag={handleAddTag}
      onRemoveTag={handleRemoveTag}
      selectedValues={selectedTags.filter(Boolean)}
      onCreateNewItem={handleAddTag}
      onModalClose={handleUpdateTags}
    />
  );
};

export { ShipmentTableTags };
